export const validation = {
  amountType: 'Please enter the amount pay',
  cardHolder: 'Please enter the card holder',
  cardNumber: 'Please enter the card number',
  expMonth: 'Expire month is required',
  expYear: 'Expire year is required',
  cvv: 'Please enter the cvv',
  checkNumber: 'Please enter the check number',
  bankName: 'Please enter the bank name',
  finance: 'Please enter the financing confirmation number',
  paymentReceipt: 'Payment receipt is required',
  typeOfModel: 'Please enter the type of model/Browser',
  typeOfPhone: 'Please choose the type of phone',
  issueStatus: 'Please choose the issue status',
  issueDetail: 'Please enter the issue detail',
  issueMedia1: 'Media is required',
  resolvedIssueDetail: 'Please enter the resolved issue detail',
  notResolveIssueDetail: 'Please enter the not resolve issue detail',
  supplyHouseId: 'Please choose the supply house',
  maxValidDetails: 'Please enter less than 1000 characters.',
  cardHolderMax: 'Please enter less than 50 characters.',
  // Refund validation messages
  refundAmountRequired: 'Please enter refund amount',
  refundAmountValid: 'Please enter a valid amount',
  refundAmountGreaterThanZero: 'Refund amount must be greater than 0',
  bankNameRequired: 'Please enter bank name',
  checkNumberRequired: 'Please enter check number',
  reasonRequired: 'Please enter reason for refund',
  refundAmountExceedsCustomerPaid: 'Refund amount cannot be greater than customer paid amount',
  checkNumberMinLength: 'Check number must be at least 3 characters',
  checkNumberMaxLength: 'Check number cannot exceed 30 characters',
  financingNumberMinLength: 'Financing confirmation number must be at least 6 characters',
  financingNumberMaxLength: 'Financing confirmation number cannot exceed 30 characters',
  checkNumberFormat: 'Only letters, numbers, spaces, and hyphens are allowed',
  specialCharacterNotAllowed: 'Special character not allowed',
};
